import {IntermediatePart} from "../../intermediatePart";
import store from "../../../../../store";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Hood extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hood';
    this.partName = 'Hood';
    this.translateId = "visualizer.kitchen.appliance.hood";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Hood());
  }

  handleClick(ignoreLocked = false, clickFrom = "") {
    const {isEncore} = store.getState().fabricatorState;
    if (isEncore) {
      const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
      if (ignoreLocked || !featureIsLocked) {
        const applianceParent = this.getParent().getParent();
        if (applianceParent.layout.type === 6) {
          if (applianceParent.range && !applianceParent.range.disabled) {
            applianceParent.range.disabled = true;
          }
          if (applianceParent.stovetop && applianceParent.stovetop.disabled) {
            applianceParent.stovetop.disabled = false;
          }
        }
      }
    }
    return super.handleClick(ignoreLocked, clickFrom);
  }

  // add dependency on stove width, if width is 24 - we need width 30, if stove is 60 - we need 48

  disabledClick() {
    const applianceParent = this.getParent();
    const stove = applianceParent.stove;
    if (stove && !this.disabled && stove.disabled) {
      stove.disabled = false;
    }
    if ((applianceParent.layout.type === 6) && !this.disabled && applianceParent.microwave
      && !applianceParent.microwave.disabled) {
      applianceParent.microwave.disabled = true;
    }
  }

}
